export const WEEKDAYS_SHORT = [
  'FORM.WEEK_LABELS_SHORT.MONDAY',
  'FORM.WEEK_LABELS_SHORT.TUESDAY',
  'FORM.WEEK_LABELS_SHORT.WEDNESDAY',
  'FORM.WEEK_LABELS_SHORT.THURSDAY',
  'FORM.WEEK_LABELS_SHORT.FRIDAY',
  'FORM.WEEK_LABELS_SHORT.SATURDAY',
  'FORM.WEEK_LABELS_SHORT.SUNDAY',
];
